import { setFeatureFlag } from '@/utils';
const setFeatureFlagFromUrl = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    const featureFlagValue = urlParams.get('featureFlags');
    if(featureFlagValue === name) {
        setFeatureFlag( name, 'correct' );
    }
}

export default setFeatureFlagFromUrl;